import { For, ParentProps, Show, createEffect, createMemo, createSignal, onMount } from 'solid-js'
import { AgentDocumentReferenceEvent, AgentTicketReferenceEvent, requireSuppportAssistAgentContext, SuppportAssistAgentContext, SuppportAssistAgentContextJsx, TICKET_VIEW_ID } from './SupportAssistAgentContext'
import styles from './st-support-assist-agent.module.css'
import Button from '../st-button/st-button'
import Flexbox from '../st-flexbox/st-flexbox'
import Loader from '../st-loader/st-loader'
import { ConversationListItem, Sidebar } from './fragments/Sidebar'
import { ConversationComponent } from './fragments/Conversation'
import { References } from './fragments/References'
import { useViewContext } from '../st-view/st-view'

export class SuppportAssistAgentProps {
    ticketGU?: string;
}

export default function SuppportAssistAgent(props: ParentProps<SuppportAssistAgentProps>) {

    const context = new SuppportAssistAgentContext();



    return (
        <SuppportAssistAgentContextJsx.Provider value={context}>
            <SuppportAssistAgentInternal {...props} />
        </SuppportAssistAgentContextJsx.Provider>
    )
}

function SuppportAssistAgentInternal(props: ParentProps<SuppportAssistAgentProps>) {
    const view = useViewContext();
    const context = requireSuppportAssistAgentContext();
    const [collapsed, setCollapsed] = createSignal(false);

    const onlyLoadWithTicket = createMemo(() => view?.viewId() === TICKET_VIEW_ID);

    createEffect(() => {
        context.setTicketGU(view?.identity() ?? props.ticketGU);
    });

    onMount(() => {
        createEffect(() => {
            const ticketGU = context.ticketGU(); // track the ticketGU so that if it changes, we reload conversations

            context.startNewConversation();

            if (onlyLoadWithTicket()) {
                if (ticketGU) {
                    context.loadConversations();
                } else {
                    context.setConversations([]);
                }
            } else {
                context.loadConversations();
            }
        })
    })


    const references = createMemo(() => {
        return context.conversation.messages
            .flatMap(m => m.traces || [])
            .filter(t => t.type === 'agent.document_reference' || t.type === 'agent.ticket_reference') as unknown as (AgentDocumentReferenceEvent | AgentTicketReferenceEvent)[];
    })

    return (
        <div class={styles['st-support-assist-agent']} data-collapsed={collapsed()}>
            <Sidebar onCollapseClicked={(c) => setCollapsed(c)} />

            <div class={styles['conversation-panel']}>
                <div class={styles['conversation-header']}>
                    <Show when={collapsed()}>
                        <Button icon='fa-regular fa-chevron-right' type='ghost' onClick={() => setCollapsed(false)} />
                        <Button icon='fa-regular fa-pen-to-square' type='ghost' onClick={() => context.startNewConversation()} />
                    </Show>
                </div>
                <ConversationComponent />
            </div>
            <div class={styles['references-panel']} data-collapsed={!context.referencesVisible()}>
                <div class={styles['references-header']}>
                    <span>References ({references().length})</span>
                    <Button icon='fa-regular fa-xmark' type='ghost' onClick={() => context.setReferencesVisible(!context.referencesVisible())} />
                </div>

                <References />
            </div>
        </div>
    );
}

SuppportAssistAgent.defaultProps = new SuppportAssistAgentProps();